import React from "react";

function AuthenticHaitianSection() {
  return (
    <section className="pt-12 bg-amber-50">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-center">
          <div className="rounded-lg overflow-hidden shadow-lg max-w-2xl w-full">
            <img
              src={require("../assets/images/authentic-haitian.jpg")}
              alt="Haitian Community and Flag"
              className="w-full h-auto object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default AuthenticHaitianSection;
